//  PC UI库
import { 
  Button, 
  Dialog, 
  Pagination, 
  Form, 
  FormItem, 
  Input,
  Select,
  Option,
  Empty,
  Loading,
  Switch,
} from 'element-ui';

const ElComponent = [
  Button,
  Dialog,
  Pagination,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Empty,
  Loading,
  Switch,
];
export default function loadElUi(app) {
  ElComponent.forEach(component => {
    app.use(component);
  });
}
